var app = window.angular.module('MainApp');

app.filter('coins', function() {

  return function(value) {
    var postfix;
    value = value || 0;
    if(value==1){
      postfix = 'coin';
    }
    else{
      postfix = 'coins';
    }
    return `${value} ${postfix}`;
  };

});
